export default class FirebaseUtils {

    static getImageUrl(firebase, path) {
        if (firebase && path && !path.startsWith('http')) {
            return firebase.storage().ref(path).getDownloadURL()
                .catch(() => null);
        } else {
            return Promise.resolve(path);
        }
    }

}


// WEBPACK FOOTER //
// ./src/util/FirebaseUtils.js